<nz-layout>
  <nz-content>
    <ng-container>
      <app-reusable-table
        title="Current Care Teams"
        [columns]="['Template', 'Category', 'Status', 'Onset Date', 'End Date']"
        [rowFields]="[
          'careTeamTemplateName',
          'careTeamCategoryDisplay',
          'careTeamStatusDisplay',
          'onSetDate',
          'endDate',
        ]"
        [data]="careTeams"
        [isLoading]="isLoading"
        [expandComponent]="expandComp"
        [deleteFun]="deleteFun"
        [stopFun]="stopFun"
        [openModalFun]="openModalFun"
        [customActions]="careTeamCustomActions"
        [isPreview]="false"
        [addPermissions]="['a-ct']"
        [stopPermissions]="['s-ct']"
        [stopTooltip]="'Unassign Care Team'"
      />
    </ng-container>
  </nz-content>
</nz-layout>
